export default __webpack_public_path__ + "static/media/selected1.1a0f05e9.png";